import { useReduxSelector } from 'hooks';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { IStoreSession } from 'store/types';
import { IAccessControlProps } from './AccessControl';

export interface IValidateAuthenticationProps extends Pick<IAccessControlProps, 'authenticate'> {
  fallback?: React.ReactElement;
}

export const ValidateAuthentication: React.FC<IValidateAuthenticationProps> = (props) => {
  const { children, authenticate, fallback = <Navigate to="/logout" /> } = props;

  const session: IStoreSession = useReduxSelector((state) => state.session);
  const isAuthorized = !authenticate || session?.isAuthenticated;

  return isAuthorized ? <>{children}</> : fallback;
};
